import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Marquee from "../components/landing/Marquee";
import Manifesto from "../components/landing/Manifesto";
import Features from "../components/landing/Features";
import FAQ from "../components/landing/FAQ";
import CTASection from "../components/landing/CTASection";
import Footer from "../components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="relative">
      <Header />
      <Hero />
      <Marquee />
      <Manifesto />
      <Features />
      <FAQ />
      <CTASection />
      <Footer />
    </main>
  );
}
